export default __webpack_public_path__ + "static/calendar.light-0b5893cf332cff18ab7f3e6a78c69724e523df0b79eb90ed5cb5b562bf00b61d.png";